import { z } from 'zod';
import { oneOf, str } from '../../navigation/searchParams';

/**
 * The account dialogs the layout opens over any page: the profile, the tenant
 * switcher and platform settings, with the dialog's inner tab. Every admin
 * page's search carries these alongside its own.
 */
export const adminLayoutSearch = z.object({
  account: oneOf(['profile', 'switch-tenant', 'platform-settings']),
  accountTab: str,
});
